import React from 'react'
import Button from '../../../atoms/button/button'
import { StaticImage } from 'gatsby-plugin-image'
import { navigate } from 'gatsby'
import getUserInfo from '../../../../utils/getUserInfo'
import { pushEventData } from '../../../../utils/pushEventDataLayer'
import { jsonToHash } from '../../../../utils/crypto'
import { $Redime, $redimir, WORDS } from '../../../../constants/keywords'
import { getParagraph3, text1, text2 } from './tabs2.textbylocale'

const handlerGoToGame = () => {
  navigate('/game')
}

const userInfo = getUserInfo()
const toggleButton = async evt => {
  if (evt) {
    let text = evt.target?.innerText
    if (text) {
      if (text) {
        pushEventData({
          event: 'Interacciones_Home_RompeTabus',
          category: 'Redime',
          label: text,
          user_data: userInfo && [
            await jsonToHash({
              nombre: userInfo.name,
              apellido: userInfo.lastName,
              celular: userInfo.cellPhone,
              correo: userInfo.email,
              ciudad: userInfo.location.cityName,
              departamento: userInfo.location.countryStateName,
              pais: userInfo.countryName,
            }),
          ],
          log_status: userInfo ? 'Yes' : 'Not',
        })
      }
    }
  }
  handlerGoToGame()
}

const Tab2 = ({ isMobile }) => {
  return (
    <>
      {isMobile && <h3>{$Redime}</h3>}
      <StaticImage
        src="../../../../assets/images/tabs-section/logoMbTab2.webp"
        alt="Logo inicio sesion"
        className="tab-content__imgTab2"
        placeholder="blurred"
      />
      <div className="tab-content__info">
        <div className="tab-content__text">
          <p>
            {text1()} <span>{$redimir}</span>
          </p>
          <div className="tab-content__text__logoPuntos">
            <StaticImage
              src="../../../../assets/images/tabs-section/logo25Puntos.webp"
              alt="logo 25 puntos"
              placeholder="blurred"
            />
          </div>
          <p> de tus puntos acumulados </p>
          <br />
          {text2(isMobile)}
          <br />
          <br />
          {getParagraph3()}
        </div>

        {isMobile && <br />}
        <Button className="--btnTabs" onClick={toggleButton}>
          {WORDS.Aqui}
        </Button>
      </div>
    </>
  )
}

export default Tab2
